import "./Header.css";
import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Logo from "../images/logo.png";

const Header = () => {
  const [contentsUser, setContentsUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [contentsCategories, setContentsCategories] = useState(null);
  const [loadingCategories, setLoadingCategories] = useState(true);

  useEffect(() => {
    const data = {
      deviceId: 'fcb9ef9019deac5377532c3824c3061c'
    };

    // Check device
    fetch(window.backendDomain + '/api/v1/profile/check-device', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-type': 'application/json',
        'auth-token': localStorage.getItem('token')
      }
    })
      .then(res => res.json())
      .then(json => {
        if (json.status === 'OK' && json.data && json.data.status === 0) {
          localStorage.removeItem("token");
          window.location = "/#/login";
        }
      });

    // Fetch user
    fetch(window.backendDomain + '/api/v1/profile/view', {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'auth-token': localStorage.getItem('token')
      }
    })
      .then(res => res.json())
      .then(json => {
        if (json.status === 'OK') {
          setContentsUser(json.data);
          localStorage.setItem('userId', json.data.user._id);
          window.contentsUser = json.data;
          setLoadingUser(false);

          // Fetch categories
          fetch(window.backendDomain + '/api/v1/contents/categories/view', {
            method: 'GET',
            headers: {
              'Content-type': 'application/json',
              'auth-token': localStorage.getItem('token')
            }
          })
            .then(res => res.json())
            .then(json => {
              if (json.status === 'OK') {
                setContentsCategories(json.data);
                setLoadingCategories(false);
              }
            });
        } else {
          localStorage.removeItem("token");
          window.location = "/#/login";
        }
      });
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    window.location = "/#/login";
  };

  return (
    <Navbar collapseOnSelect expand="lg" className="header" fixed="top" variant="dark">
      <Container style={{ padding: 0, alignItems: 'center' }}>
        <Navbar.Brand as={Link} to="/">
          <img src={Logo} alt="OyaWatch Logo" height="50px" />
        </Navbar.Brand>

        <Navbar.Toggle className="fa fa-bars white" aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">

          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" className="link home-link">HOME</Nav.Link>

            {!loadingCategories && (
              <>
                {contentsCategories?.content[0]?.status === 1 && (
                  <NavDropdown title="LIVE CHANNELS" id="collasible-nav-dropdown">
                    <NavDropdown.Item as={Link} to="/channels/all" className="link">
                      ALL CHANNELS
                    </NavDropdown.Item>
                    {contentsCategories.channelsCategory.map(item => (
                      <NavDropdown.Item
                        key={item._id}
                        as={Link}
                        to={`/channels/${item._id}`}
                        className="link"
                      >
                        {item.name.toUpperCase()}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                )}

                {contentsCategories?.content[1]?.status === 1 && (
                  <NavDropdown title="VOD" id="collasible-nav-dropdown">
                    <NavDropdown.Item as={Link} to="/vods/all" className="link">
                      ALL VOD
                    </NavDropdown.Item>
                    {contentsCategories.vodsCategory.map(item => (
                      <NavDropdown.Item
                        key={item._id}
                        as={Link}
                        to={`/vods/${item._id}`}
                        className="link"
                      >
                        {item.name.toUpperCase()}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                )}
              </>
            )}
          </Nav>

          <Nav>
            {!loadingUser && (
              <NavDropdown title={contentsUser.user.name.toUpperCase()} id="collasible-nav-dropdown">
                <NavDropdown.Item as={Link} to="/my-account" className="link">
                  <i className="fa fa-user"></i> MY ACCOUNT
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/manage-subscription" className="link">
                  <i className="fa fa-credit-card"></i> MANAGE SUBSCRIPTION
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={logout}>
                  <i className="fa fa-sign-out"></i> LOGOUT
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
